export default {
  pay_popup: {
    card_pay: 'Payment cards',
    card_pay_des: 'Cancel or manage your subscription in Stripe\'s \'Settings\'.'
  }
}
